import { render, staticRenderFns } from "./PortalTopicWidget.vue?vue&type=template&id=19b2d556&"
import script from "./PortalTopicWidget.vue?vue&type=script&lang=ts&"
export * from "./PortalTopicWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports